import React from 'react';
import {
  Checkbox, Form as AntdForm, Typography, Button,
} from 'antd';
import { Action, AnyObject } from '@triare/auth-redux';
import {
  Callbacks,
  Rule,
  ValidateErrorEntity,
} from 'rc-field-form/lib/interface';
import { FormProps as AntdFormProps } from 'rc-field-form/lib/Form';
import clsx from 'clsx';
import {
  SignInByPhoneAction,
  SignInByUsernameAction,
} from '@triare/auth-redux/dist/saga/auth/signIn';
import { useAuth } from '../../../../../store/auth';
import AlertSuccess, { AlertSuccessProps } from './Alert/Success';
import AlertError, { AlertErrorProps } from './Alert/Error';
import Submit from '../../../../Common/Form/Button/Submit';
import { IconTipping } from '../../../../Common/Icon';

import styles from '../../index.module.scss';

interface FormProps<P> extends AntdFormProps {
  disableAlertSuccess?: true;
  requiredFields?: '*' | string[];
  validationRules: Rule;
  styles?: { [key: string]: string };

  children: React.ReactNode;
  alertSuccess?: AlertSuccessProps;
  alertError?: AlertErrorProps;

  signIn: (payload: P) => Action | void;
  onFinishFailed?: Callbacks<P>['onFinishFailed'];
  validateSubmit: (fieldsValue: AnyObject) => boolean;
  setForgotOpen?: () => void;
}

function Form<P = SignInByPhoneAction | SignInByUsernameAction>({
  disableAlertSuccess,
  validationRules,
  validateSubmit,
  requiredFields = '*',
  styles: additionalStyles = {},
  form,
  children,
  alertSuccess,
  alertError,
  signIn,
  setForgotOpen,
  initialValues = { remember: true },
  onFinishFailed = (errorInfo: ValidateErrorEntity<P>) => {
    console.log('Failed:', errorInfo);
  },
  ...props
}: FormProps<P>): React.ReactElement {
  const {
    signIn: { loading, response },
  } = useAuth();

  return (
    <AntdForm
      className={clsx(styles.form, additionalStyles?.form)}
      name="signIn"
      autoComplete="off"
      layout="vertical"
      onFinish={signIn}
      onFinishFailed={onFinishFailed}
      initialValues={initialValues}
      {...props}
    >
      {/* <Typography.Text className={styles.text} strong>
        Log in using your credentials
      </Typography.Text> */}
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <IconTipping />
        <h4 style={{ marginTop: '15px' }}>Welcome to TippingGuide.com!</h4>
        <span style={{ fontWeight: 300 }}>
          Enter your credentials to access your account.
        </span>
      </div>

      <div className={styles.alertWrapper}>
        {disableAlertSuccess ? null : (
          <AlertSuccess response={response} {...alertSuccess} />
        )}
        <AlertError {...alertError} />
      </div>

      {children}

      <AntdForm.Item>
        {/* <AntdForm.Item
          className={clsx(styles?.remember, additionalStyles?.remember)}
          name="remember"
          valuePropName="checked"
          noStyle
        >
          <Checkbox>Remember me</Checkbox>
        </AntdForm.Item> */}

        {/* <NavLink
          to="/forgot-password"
          style={{
            float: 'right', color: 'black', textDecoration: 'underline', fontSize: '17px', fontWeight: '700',
          }}
        >
          Forgot password?
        </NavLink> */}
        <Button
          type="link"
          onClick={() => setForgotOpen?.()}
          style={{
            float: 'right',
            color: 'black',
            textDecoration: 'underline',
            fontSize: '17px',
            fontWeight: '700',
          }}
        >
          Forgot password?
        </Button>
      </AntdForm.Item>

      <Submit
        validateSubmit={validateSubmit}
        requiredFields={requiredFields}
        itemClassName={clsx(styles.submit, additionalStyles?.submit)}
        loading={loading}
        className={styles.btn}
        size="large"
      >
        Continue
      </Submit>
    </AntdForm>
  );
}

export default Form;
